module.exports = __webpack_public_path__ + "img/mic-logo-light.bf1d7c22.svg";